import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogActions, Button, IconButton, Tabs, Tab  } from "@mui/material";
import { MapContainer, TileLayer, Polyline, Popup, useMap, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { UpdateStatusCable } from "../UpdateData/UpdateStatusComponent";
import { CABLE, iconCoupling, iconFob, iconManhole, iconPillar, iconPonBox } from "../Constants/ConstantsOptics";
import { Snackbar } from '@mui/material';
import CustomSnackbar from "../Components/CustomSnackbar";
import { GET_FASTENING_ERRORS_CABLE_API_URL, GET_FASTENING_ERRORS_CABLE_ID_API_URL, GET_FASTENING_ERRORS_COUPLING_ID_API_URL, GET_FASTENING_ERRORS_FOB_ID_API_URL, GET_FASTENING_ERRORS_PILLAR_ID_API_URL, GET_FASTENING_ERRORS_PON_BOX_ID_API_URL, GET_FASTENING_ERRORS_WELL_ID_API_URL, UPDATE_FASTENING_ERRORS_CABLE_API_URL, UPDATE_FASTENING_ERRORS_COUPLING_API_URL, UPDATE_FASTENING_ERRORS_FOB_API_URL, UPDATE_FASTENING_ERRORS_PILLAR_API_URL, UPDATE_FASTENING_ERRORS_POB_BOX_API_URL, UPDATE_FASTENING_ERRORS_WELL_API_URL } from "../OpticApiConfig";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const ModalFasteningErrors = ({ open, onClose, user, role }) => {
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [selectedComponent, setSelectedComponent] = useState("");
  const [cableData, setCableData] = useState([]); 
  const [expandedHighwayLineId, setExpandedHighwayLineId] = useState(null); 
  const [mapCenter, setMapCenter] = useState([0, 0]); 
  const [mapZoom, setMapZoom] = useState(13);
  const [selectedLineCoordinates, setSelectedLineCoordinates] = useState([]);
  const [successfulIds, setSuccessfulIds] = useState([]); 
  const [highwayIds, setHighwayIdsIds] = useState([]);
  const [cableParameters, setCableParameters] = useState({});
  const [tabIndex, setTabIndex] = useState(0);
  const [inputId, setInputId] = useState('');
  const [visibleRows, setVisibleRows] = useState({}); 
  const token = localStorage.getItem('token');

  const [inputPonBoxId, setInputPonBoxId] = useState('');
  const [successPonBoxId, setSuccessPonBoxId] = useState([]);
  const [foundPonBox, setFoundPonBox] = useState(null);

  const [inputCouplingId, setInputCouplingId] = useState('');
  const [successCouplingId, setSuccessCouplingId] = useState([]);
  const [foundCoupling, setFoundCoupling] = useState(null);

  const [inputFobId, setInputFobId] = useState('');
  const [successFobId, setSuccessFobId] = useState([]);
  const [foundFob, setFoundFob] = useState(null);

  const [inputPillarId, setInputPillarId] = useState('');
  const [successPillarId, setSuccessPillarId] = useState([]);
  const [foundPillar, setFoundPillar] = useState(null);

  const [inputWellId, setInputWellId] = useState('');
  const [successWellId, setSuccessWellId] = useState([]);
  const [foundWell, setFoundWell] = useState(null);


  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  useEffect(() => {
    if (cableData && cableData.length > 0) { // Проверяем наличие данных
      const initialVisibleRows = {};
      cableData.forEach((item) => {
        initialVisibleRows[item.highwayLineId] = 1; // Устанавливаем значение 1 для каждой линии
      });
      setVisibleRows(initialVisibleRows);
    }
  }, [cableData]);
  
  const handleAddRow = (highwayLineId) => {
    setVisibleRows((prev) => {
      const currentVisible = prev[highwayLineId] || 1;
  
      // Увеличиваем только если осталось что показывать
      if (currentVisible < cableData.find((item) => item.highwayLineId === highwayLineId).rows.length) {
        return {
          ...prev,
          [highwayLineId]: currentVisible + 1,
        };
      }
  
      return prev; // Ничего не делаем, если больше показывать нечего
    });
  };
  
  const handleRemoveRow = (highwayLineId) => {
    setVisibleRows((prev) => {
      const currentVisible = prev[highwayLineId] || 1;
  
      // Уменьшаем только если больше одной строки показывается
      if (currentVisible > 1) {
        return {
          ...prev,
          [highwayLineId]: currentVisible - 1,
        };
      }
  
      return prev; // Ничего не делаем, если меньше нельзя
    });
  };
  
  

  const handleSelectChange = (event) => {
    setSelectedComponent(event.target.value);
  };

  //поиск кабеля
  const handleSearchIdClick = async () => {
    if (inputId != '') {
      try {
        
        const response = await fetch(
          `${GET_FASTENING_ERRORS_CABLE_ID_API_URL}?cableId=${inputId}&authorId=${user}&role=${role}`,{
            headers:{
              'Authorization': `Bearer ${token}` 
            }
          }
        );
        const data = await response.json();
        setCableData(data);
      } catch (error) {
        console.error("Ошибка при получении данных кабеля:", error);
      }
    } else {
      setSelectedComponent("");
      setCableData([]);
      setExpandedHighwayLineId(null);
      setMapCenter([0, 0]);
      setMapZoom(13);
      setSelectedLineCoordinates([]);
      setSuccessfulIds([]);
      setHighwayIdsIds([]);
      setInputId('');
    }
  };

 
  const handleSearchClick = async () => {
    if (selectedComponent === CABLE) {
      try {
        
        const response = await fetch(`${GET_FASTENING_ERRORS_CABLE_API_URL}?name=${user}`);
        const data = await response.json();
        setCableData(data);
      } catch (error) {
        console.error("Ошибка при получении данных кабеля:", error);
      }
    } else {
      setSelectedComponent("");
      setCableData([]);
      setExpandedHighwayLineId(null);
      setMapCenter([0, 0]);
      setMapZoom(13);
      setSelectedLineCoordinates([]);
      setSuccessfulIds([]);
      setHighwayIdsIds([]);
    }
  };

  const toggleRows = (highwayLineId, cableColor, cableKind, cableWidth, cableName, description, coordinates) => {  

    setExpandedHighwayLineId((prevId) => (prevId === highwayLineId ? null : highwayLineId));

    if (coordinates && coordinates.length > 0) {
      setSelectedLineCoordinates(coordinates);
      setCableParameters({ cableColor, cableKind, cableWidth, cableName, description }); 
      setMapCenter(coordinates[0]); 
      setMapZoom(16);
    }
};

  const handleDeleteCable = async (highwayLineId) => {
    UpdateStatusCable(CABLE, highwayLineId, showSnackbar, user, handleSearchClick);
  };
  

  const handleFixClick = async (rowId, highwayLineId, inputValue) => {
  
    if (!inputValue) {
      showSnackbar('Укажите ветку', 'snackbarWarning');
      return;
    }
  
    const requestBody = {
      Area: inputValue, 
      AuthorId: "ADMIN" 
    };
  
    try {
      const response = await fetch(`${UPDATE_FASTENING_ERRORS_CABLE_API_URL}${rowId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      if (response.ok) {
        const responseData = await response.json(); 
        showSnackbar(responseData.message, 'snackbarWarning');
        setSuccessfulIds((prev) => ({
          ...prev,
          [rowId]: { 
            canton: responseData.canton, 
            region: responseData.region, 
            area: responseData.area,
          }
        }));
        setHighwayIdsIds((prev) => [...prev, highwayLineId]);
      } else {
        const errorData = await response.json();
        showSnackbar(`Ошибка`, 'snackbarWarning');
      }
    } catch (error) {
      showSnackbar(`Произошла ошибка при связи с сервером`, 'snackbarWarning');
    }
  };

  const remainingCount = Math.max(0, cableData.length - highwayIds.length);


  const handleClose = () => {
    setCableParameters({});
    setSelectedComponent("");
    setCableData([]);
    setExpandedHighwayLineId(null);
    setMapCenter([0, 0]);
    setMapZoom(13);
    setSelectedLineCoordinates([]);
    setSuccessfulIds([]);
    setHighwayIdsIds([]);
    setTabIndex(0);
    setInputId(''); 
    setInputPonBoxId('');
    setFoundPonBox(null);
    setInputCouplingId('');
    setFoundCoupling(null);
    setInputFobId('');
    setFoundFob(null);
    setInputPillarId('');
    setFoundPillar(null);
    setInputWellId('');
    setFoundWell(null);
    onClose();   

  };

  const MapUpdater = () => {
    const map = useMap();
    map.setView(mapCenter, mapZoom);
    return null;
  };



 // ПОН-БОКС--------------------------------------------------------------------------------------
 const handleSearchIdPonBoxClick = async () => {
  if (inputPonBoxId != '') {
    try {
      
      const response = await fetch(
        `${GET_FASTENING_ERRORS_PON_BOX_ID_API_URL}?ponBoxId=${inputPonBoxId}&authorId=${user}&role=${role}`,{
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        }
      );
      const data = await response.json();

      // Дожди обновления состояния и затем ищи нужный объект
      const foundBox = data.find(item => item.id === Number(inputPonBoxId));

      if (foundBox && foundBox.latitude && foundBox.longitude) {
        setFoundPonBox(foundBox);
        setMapCenter([foundBox.latitude, foundBox.longitude]);
      } else {
        console.error("Координаты для пон-бокса не найдены или они некорректны.");
      }
    } catch (error) {
      console.error("Ошибка при получении данных пон-бокса:", error);
    }
  } else {
    setSelectedComponent("");
    setFoundPonBox(null);
    setMapCenter([0, 0]);
    setMapZoom(13);
    setSuccessPonBoxId([]);
    setInputPonBoxId('');
  }
};

  const handleFixPonBoxClick = async (id, inputValue) => {
  
    if (!inputValue) {
      showSnackbar('Укажите ветку', 'snackbarWarning');
      return;
    }
  
    const requestBody = {
      Area: inputValue, 
      AuthorId: "ADMIN" 
    };
  
    try {
      const response = await fetch(`${UPDATE_FASTENING_ERRORS_POB_BOX_API_URL}${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      if (response.ok) {
        const responseData = await response.json(); 
        showSnackbar(responseData.message, 'snackbarWarning');
        setSuccessPonBoxId((prev) => ({
          ...prev,
          [id]: { 
            canton: responseData.canton, 
            region: responseData.region, 
            area: responseData.area,
          }
        }));
      
      } else {
        const errorData = await response.json();
        showSnackbar(`Ошибка`, 'snackbarWarning');
      }
    } catch (error) {
      showSnackbar(`Произошла ошибка при связи с сервером`, 'snackbarWarning');
    }
  };

  //  МУФТА --------------------------------------------------------------------------------------
 const handleSearchIdCouplingClick = async () => {
  if (inputCouplingId != '') {
    try {
      
      const response = await fetch(
        `${GET_FASTENING_ERRORS_COUPLING_ID_API_URL}?couplingId=${inputCouplingId}&authorId=${user}&role=${role}`,{
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        }
      );
      const data = await response.json();

      // Дожди обновления состояния и затем ищи нужный объект
      const foundCoupling = data.find(item => item.id === Number(inputCouplingId));

      if (foundCoupling && foundCoupling.latitude && foundCoupling.longitude) {
        setFoundCoupling(foundCoupling);
        setMapCenter([foundCoupling.latitude, foundCoupling.longitude]);
      } else {
        console.error("Координаты для муфты не найдены или они некорректны.");
      }
    } catch (error) {
      console.error("Ошибка при получении данных муфты:", error);
    }
  } else {
    setSelectedComponent("");
    setFoundCoupling(null);
    setMapCenter([0, 0]);
    setMapZoom(13);
    setSuccessCouplingId([]);
    setInputCouplingId('');
  }
};

  const handleFixCouplingClick = async (id, inputValue) => {
  
    if (!inputValue) {
      showSnackbar('Укажите ветку', 'snackbarWarning');
      return;
    }
  
    const requestBody = {
      Area: inputValue, 
      AuthorId: "ADMIN" 
    };
  
    try {
      const response = await fetch(`${UPDATE_FASTENING_ERRORS_COUPLING_API_URL}${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      if (response.ok) {
        const responseData = await response.json(); 
        showSnackbar(responseData.message, 'snackbarWarning');
        setSuccessCouplingId((prev) => ({
          ...prev,
          [id]: { 
            canton: responseData.canton, 
            region: responseData.region, 
            area: responseData.area,
          }
        }));
      
      } else {
        const errorData = await response.json();
        showSnackbar(`Ошибка`, 'snackbarWarning');
      }
    } catch (error) {
      showSnackbar(`Произошла ошибка при связи с сервером`, 'snackbarWarning');
    }
  };

   //  FOB --------------------------------------------------------------------------------------
 const handleSearchIdFobClick = async () => {
  if (inputFobId != '') {
    try {
      
      const response = await fetch(
        `${GET_FASTENING_ERRORS_FOB_ID_API_URL}?fobId=${inputFobId}&authorId=${user}&role=${role}`,{
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        }
      );
      const data = await response.json();

      // Дожди обновления состояния и затем ищи нужный объект
      const foundFob = data.find(item => item.id === Number(inputFobId));

      if (foundFob && foundFob.latitude && foundFob.longitude) {
        setFoundFob(foundFob);
        setMapCenter([foundFob.latitude, foundFob.longitude]);
      } else {
        console.error("Координаты для фоб не найдены или они некорректны.");
      }
    } catch (error) {
      console.error("Ошибка при получении данных фоб:", error);
    }
  } else {
    setSelectedComponent("");
    setFoundFob(null);
    setMapCenter([0, 0]);
    setMapZoom(13);
    setSuccessFobId([]);
    setInputFobId('');
  }
};

  const handleFixFobClick = async (id, inputValue) => {
  
    if (!inputValue) {
      showSnackbar('Укажите ветку', 'snackbarWarning');
      return;
    }
  
    const requestBody = {
      Area: inputValue, 
      AuthorId: "ADMIN" 
    };
  
    try {
      const response = await fetch(`${UPDATE_FASTENING_ERRORS_FOB_API_URL}${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      if (response.ok) {
        const responseData = await response.json(); 
        showSnackbar(responseData.message, 'snackbarWarning');
        setSuccessFobId((prev) => ({
          ...prev,
          [id]: { 
            canton: responseData.canton, 
            region: responseData.region, 
            area: responseData.area,
          }
        }));
      
      } else {
        const errorData = await response.json();
        showSnackbar(`Ошибка`, 'snackbarWarning');
      }
    } catch (error) {
      showSnackbar(`Произошла ошибка при связи с сервером`, 'snackbarWarning');
    }
  };

  //  ОПОРА --------------------------------------------------------------------------------------
 const handleSearchIdPillarClick = async () => {
  if (inputPillarId != '') {
    try {
      
      const response = await fetch(
        `${GET_FASTENING_ERRORS_PILLAR_ID_API_URL}?pillarId=${inputPillarId}&authorId=${user}&role=${role}`,{
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        }
      );
      const data = await response.json();

      // Дожди обновления состояния и затем ищи нужный объект
      const foundPillar = data.find(item => item.id === Number(inputPillarId));

      if (foundPillar && foundPillar.latitude && foundPillar.longitude) {
        setFoundPillar(foundPillar);
        setMapCenter([foundPillar.latitude, foundPillar.longitude]);
      } else {
        console.error("Координаты для опоры не найдены или они некорректны.");
      }
    } catch (error) {
      console.error("Ошибка при получении данных опоры:", error);
    }
  } else {
    setSelectedComponent("");
    setFoundPillar(null);
    setMapCenter([0, 0]);
    setMapZoom(13);
    setSuccessPillarId([]);
    setInputPillarId('');
  }
};

    const handleFixPillarClick = async (id, inputValue) => {
  
    if (!inputValue) {
      showSnackbar('Укажите ветку', 'snackbarWarning');
      return;
    }
  
    const requestBody = {
      Area: inputValue, 
      AuthorId: "ADMIN" 
    };
  
    try {
      const response = await fetch(`${UPDATE_FASTENING_ERRORS_PILLAR_API_URL}${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      if (response.ok) {
        const responseData = await response.json(); 
        showSnackbar(responseData.message, 'snackbarWarning');
        setSuccessPillarId((prev) => ({
          ...prev,
          [id]: { 
            canton: responseData.canton, 
            region: responseData.region, 
            area: responseData.area,
          }
        }));
      
      } else {
        const errorData = await response.json();
        showSnackbar(`Ошибка`, 'snackbarWarning');
      }
    } catch (error) {
      showSnackbar(`Произошла ошибка при связи с сервером`, 'snackbarWarning');
    }
  };

  //  КОЛОДЕЦ --------------------------------------------------------------------------------------
 const handleSearchIdWellClick = async () => {
  if (inputWellId != '') {
    try {
      
      const response = await fetch(
        `${GET_FASTENING_ERRORS_WELL_ID_API_URL}?wellId=${inputWellId}&authorId=${user}&role=${role}`,{
          headers:{
            'Authorization': `Bearer ${token}` 
          }
        }
      );
      const data = await response.json();

      // Дожди обновления состояния и затем ищи нужный объект
      const foundWell = data.find(item => item.id === Number(inputWellId));

      if (foundWell && foundWell.latitude && foundWell.longitude) {
        setFoundWell(foundWell);
        setMapCenter([foundWell.latitude, foundWell.longitude]);
      } else {
        console.error("Координаты для колодца не найдены или они некорректны.");
      }
    } catch (error) {
      console.error("Ошибка при получении данных колодца:", error);
    }
  } else {
    setSelectedComponent("");
    setFoundWell(null);
    setMapCenter([0, 0]);
    setMapZoom(13);
    setSuccessWellId([]);
    setInputWellId('');
  }
};

    const handleFixWellClick = async (id, inputValue) => {
  
    if (!inputValue) {
      showSnackbar('Укажите ветку', 'snackbarWarning');
      return;
    }
  
    const requestBody = {
      Area: inputValue, 
      AuthorId: "ADMIN" 
    };
  
    try {
      const response = await fetch(`${UPDATE_FASTENING_ERRORS_WELL_API_URL}${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    
      if (response.ok) {
        const responseData = await response.json(); 
        showSnackbar(responseData.message, 'snackbarWarning');
        setSuccessWellId((prev) => ({
          ...prev,
          [id]: { 
            canton: responseData.canton, 
            region: responseData.region, 
            area: responseData.area,
          }
        }));
      
      } else {
        const errorData = await response.json();
        showSnackbar(`Ошибка`, 'snackbarWarning');
      }
    } catch (error) {
      showSnackbar(`Произошла ошибка при связи с сервером`, 'snackbarWarning');
    }
  };


 

  return (
    <Dialog open={open} className="modalStyle" fullWidth maxWidth={false}>
      <DialogContent>
       <Tabs value={tabIndex} onChange={handleTabChange} TabIndicatorProps={{ style: { backgroundColor: '#dfab01'} }} textColor="inherit" sx={{ '& .MuiTab-root': { color: '#dfab01' }, '& .Mui-selected': { color: '#dfab01' } }}>
          <Tab label="Косяки закрепления" style={{fontSize: "12px",textShadow: '2px 2px 4px #242424'} } />
          <Tab label="Закрепить кабель" style={{fontSize: "12px",textShadow: '2px 2px 4px #242424'} }/>
          <Tab label="Закрепить пон-бокс" style={{fontSize: "12px",textShadow: '2px 2px 4px #242424' } }/>
          <Tab label="Закрепить муфту" style={{fontSize: "12px" ,textShadow: '2px 2px 4px #242424'} }/>
          <Tab label="Закрепить фоб" style={{fontSize: "12px",textShadow: '2px 2px 4px #242424' } }/>
          <Tab label="Закрепить опору" style={{fontSize: "12px",textShadow: '2px 2px 4px #242424' } }/>
          <Tab label="Закрепить колодец" style={{fontSize: "12px",textShadow: '2px 2px 4px #242424' } }/>
        </Tabs>
        <hr className="horizontalLineModal" />

        {/* Косяки закрепления */}
        {tabIndex === 0 && (
          <>
            <div>
              <select
                className="selectStyleModalDescription"
                value={selectedComponent}
                onChange={handleSelectChange}
              >
                <option value="">Тип компонента</option>
                <option value={CABLE}>Кабель</option>
              
                {/* <option value="PILLAR">Опора</option> */}
                {/* <option value="WELL">Колодец</option> */}
                {/* <option value="COUPLING">Муфта</option>
                <option value="FOB">Фоб</option>
              
                <option value="PON_BOX">Пон-бокс</option> */}
              </select>

              <button className="buttonIsDescriptionModal" onClick={handleSearchClick} style={{textShadow: '2px 2px 4px #242424'}}>
                Поиск
              </button>
              <label style={{ marginLeft: "10px", fontSize: "18px", color: "#d3d3d3" }}>
                Всего: <span style={{ color: "orange" }}>{remainingCount}</span>
              </label>
            </div>

            <div style={{ display: "flex" }}>
              <div style={{ flex: 1, maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                {cableData.length > 0 && (
                  <div>
                    {cableData.map((item, itemIndex) => (
                      
                      <div key={`highway-${itemIndex}`} className='divBodyConnectModal'>
                        <div
                        
                          style={{ cursor: "pointer", fontWeight: "bold", display: "flex", alignItems: "center"}}
                          onClick={() => {
                            if (item.rows && item.rows.length > 0) {
                              toggleRows(
                                item.highwayLineId, 
                                item.rows[0].cableColor,  
                                item.rows[0].cableKind,
                                item.rows[0].cableWidth, 
                                item.rows[0].cableName, 
                                item.rows[0].description, 
                                item.rows.map((row) => [row.latitude, row.longitude])  
                              );
                            }
                          }}                    >
                        
                            <span style={{ color: "#3f3f3f" }}>Кабель ID:</span>{" "}
                            <span style={{ color: "#252525", fontWeight: "normal" }}>{item.highwayLineId}</span>
                          {/* Показываем картинку, если ID есть в successfulIds */}
                          {highwayIds.includes(item.highwayLineId) && (
                            
                            <img
                              src='./ok.png'
                              alt="OK"
                              style={{
                                width: "25px",
                                height: "25px",
                                marginLeft: "20px",
                                verticalAlign: "middle",
                              }}
                            />
                          )}

                          <button className="buttonIsDeleteModal2" style={{ marginLeft: "auto" }}
                            onClick={(e) => {
                              e.stopPropagation(); 
                              handleDeleteCable(item.highwayLineId);
                            }}
                          >
                              Удалить
                          </button>                   
                      </div>
                        {expandedHighwayLineId === item.highwayLineId && (
                            <div style={{ paddingLeft: "20px" }} className="divBodyConnectModal">
                              <span style={{ color: "#dfdfdf" }}>
                                Еще доступных закреплений:
                              </span>{" "}
                              <span style={{ color: "#7fd17f", fontWeight: "bold" }}>
                                {item.rows.length - visibleRows[item.highwayLineId]}
                              </span>
              <hr className="horizontalLineDialog" />
              {item.rows &&
                item.rows.slice(0, visibleRows[item.highwayLineId] || 1).map((row) => {
                  const successfulCable = successfulIds[row.id];  
                  return (
                    <div key={row.id} style={{ gap: "10px" }}>
                      <span>
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Округ:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successfulCable ? successfulCable.canton : row.canton}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Регион:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successfulCable ? successfulCable.region : row.region}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Ветка:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successfulCable ? successfulCable.area : row.area}
                        </span>
                      </span>
                      <br />
                      <input
                        type="number"
                        placeholder="номер ветки"
                        style={{ marginLeft: "10px" }}
                        className="inputDescriptionModal"
                      />
                      <button
                        className="buttonIsSaveDialog2"
                        onClick={(e) => handleFixClick(row.id, item.highwayLineId, e.target.previousSibling.value)}
                      >
                        Закрепить
                      </button>
                      <hr className="horizontalLineDialog" />
                    </div>
                  );
                })}

          <div>
          <IconButton onClick={() => handleAddRow(item.highwayLineId)}>
            <AddIcon style={{ color: 'green' }}/>
          </IconButton>

          <IconButton  onClick={() => handleRemoveRow(item.highwayLineId)}>
            <RemoveIcon style={{ color: '#e64848' }}/>
          </IconButton>
          </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div style={{ flex: 1, height: "400px", marginLeft: "20px" }}>
                <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <MapUpdater /> 
                  {selectedLineCoordinates.length > 0 && (
                    <Polyline 
                      key={JSON.stringify(selectedLineCoordinates)}  
                      positions={selectedLineCoordinates} 
                      color={cableParameters.cableColor} 
                      weight={cableParameters.cableWidth}
                      dashArray={cableParameters.cableKind !== 'solid ' ? '5,10' : null}   
                      >
                      <Popup autoClose={false} className="custom-popup">
                      <label style={{ fontSize: '13px' }}>
                        <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                        <span style={{ color: '#363636' }}>{expandedHighwayLineId}</span>
                      </label>
                      <br/>
                      <label style={{ fontSize: '13px' }}>
                        <span style={{ color: '#000000', fontWeight: 'bold' }}>Кабель: </span>
                        <span style={{ color: '#363636' }}>{cableParameters.cableName}</span>
                      </label>
                      <br/>
                      <label style={{ fontSize: '13px' }}>
                        <span style={{ color: '#000000', fontWeight: 'bold' }}>Комментарий: </span>
                        <span style={{ color: '#363636' }}>{cableParameters.description}</span>
                      </label>
                      </Popup>
                    </Polyline>
                  )}
                </MapContainer>
              </div>
            </div>
            </>


            )}

        {/* Перезакрепление КАБЕЛЬ по ID */}
        {tabIndex === 1 && (
             <>
             <div>
              <input
                  type="number"
                  placeholder="Введите ID кабеля"
                  className="inputDescriptionModal"
                  style={{width: '180px'}}
                  value={inputId}
                  onChange={(e) => setInputId(e.target.value)}
                />
 
               <button className="buttonIsDescriptionModal" onClick={handleSearchIdClick} style={{textShadow: '2px 2px 4px #242424'}}>
                 Поиск
               </button>
             </div>
 
             <div style={{ display: "flex" }}>
               <div style={{ flex: 1, maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                 {cableData.length > 0 && (
                   <div>
                     {cableData.map((item, itemIndex) => (
                       
                       <div key={`highway-${itemIndex}`} className='divBodyConnectModal'>
                         <div
                         
                           style={{ cursor: "pointer", fontWeight: "bold", display: "flex", alignItems: "center"}}
                           onClick={() => {
                             if (item.rows && item.rows.length > 0) {
                               toggleRows(
                                 item.highwayLineId, 
                                 item.rows[0].cableColor,  
                                 item.rows[0].cableKind,
                                 item.rows[0].cableWidth, 
                                 item.rows[0].cableName, 
                                 item.rows[0].description, 
                                 item.rows.map((row) => [row.latitude, row.longitude])  
                               );
                             }
                           }}                    >
                         
                             <span style={{ color: "#3f3f3f" }}>Кабель ID:</span>{" "}
                             <span style={{ color: "#252525", fontWeight: "normal" }}>{item.highwayLineId}</span>
                           {/* Показываем картинку, если ID есть в successfulIds */}
                           {highwayIds.includes(item.highwayLineId) && (
                             
                             <img
                               src='./ok.png'
                               alt="OK"
                               style={{
                                 width: "25px",
                                 height: "25px",
                                 marginLeft: "20px",
                                 verticalAlign: "middle",
                               }}
                             />
                           )}
 
                           <button className="buttonIsDeleteModal2" style={{ marginLeft: "auto" }}
                             onClick={(e) => {
                               e.stopPropagation(); 
                               handleDeleteCable(item.highwayLineId);
                             }}
                           >
                               Удалить
                           </button>                   
                       </div>
                         {expandedHighwayLineId === item.highwayLineId && (
                             <div style={{ paddingLeft: "20px" }} className="divBodyConnectModal">
                               <span style={{ color: "#dfdfdf" }}>
                                 Еще доступных закреплений:
                               </span>{" "}
                               <span style={{ color: "#7fd17f", fontWeight: "bold" }}>
                                 {item.rows.length - visibleRows[item.highwayLineId]}
                               </span>
               <hr className="horizontalLineDialog" />
               {item.rows &&
                 item.rows.slice(0, visibleRows[item.highwayLineId] || 1).map((row) => {
                   const successfulCable = successfulIds[row.id];  
                   return (
                     <div key={row.id} style={{ gap: "10px" }}>
                       <span>
                         <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Округ:</span>{" "}
                         <span style={{ color: "#252525" }}>
                           {successfulCable ? successfulCable.canton : row.canton}
                         </span>,{" "}
                         <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Регион:</span>{" "}
                         <span style={{ color: "#252525" }}>
                           {successfulCable ? successfulCable.region : row.region}
                         </span>,{" "}
                         <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Ветка:</span>{" "}
                         <span style={{ color: "#252525" }}>
                           {successfulCable ? successfulCable.area : row.area}
                         </span>
                       </span>
                       <br />
                       <input
                         type="number"
                         placeholder="номер ветки"
                         style={{ marginLeft: "10px" }}
                         className="inputDescriptionModal"
                       />
                       <button
                         className="buttonIsSaveDialog2"
                         onClick={(e) => handleFixClick(row.id, item.highwayLineId, e.target.previousSibling.value)}
                       >
                         Закрепить
                       </button>
                       <hr className="horizontalLineDialog" />
                     </div>
                   );
                 })}
 
           <div>
           <IconButton onClick={() => handleAddRow(item.highwayLineId)}>
             <AddIcon style={{ color: 'green' }}/>
           </IconButton>
 
           <IconButton  onClick={() => handleRemoveRow(item.highwayLineId)}>
             <RemoveIcon style={{ color: '#e64848' }}/>
           </IconButton>
           </div>
                           </div>
                         )}
                       </div>
                     ))}
                   </div>
                 )}
               </div>
 
               <div style={{ flex: 1, height: "400px", marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                   <MapUpdater /> 
                   {selectedLineCoordinates.length > 0 && (
                     <Polyline 
                       key={JSON.stringify(selectedLineCoordinates)}  
                       positions={selectedLineCoordinates} 
                       color={cableParameters.cableColor} 
                       weight={cableParameters.cableWidth}
                       dashArray={cableParameters.cableKind !== 'solid ' ? '5,10' : null}   
                       >
                       <Popup autoClose={false} className="custom-popup">
                       <label style={{ fontSize: '13px' }}>
                         <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                         <span style={{ color: '#363636' }}>{expandedHighwayLineId}</span>
                       </label>
                       <br/>
                       <label style={{ fontSize: '13px' }}>
                         <span style={{ color: '#000000', fontWeight: 'bold' }}>Кабель: </span>
                         <span style={{ color: '#363636' }}>{cableParameters.cableName}</span>
                       </label>
                       <br/>
                       <label style={{ fontSize: '13px' }}>
                         <span style={{ color: '#000000', fontWeight: 'bold' }}>Комментарий: </span>
                         <span style={{ color: '#363636' }}>{cableParameters.description}</span>
                       </label>
                       </Popup>
                     </Polyline>
                   )}
                 </MapContainer>
               </div>
             </div>
             </>
        )}

         {/* Перезакрепление ПОН-БОКС по ID */}
         {tabIndex === 2 && (
             <>
             <div>
              <input
                  type="number"
                  placeholder="Введите ID бокса"
                  className="inputDescriptionModal"
                  style={{width: '180px'}}
                  value={inputPonBoxId}
                  onChange={(e) => setInputPonBoxId(e.target.value)}
                />
 
               <button className="buttonIsDescriptionModal" onClick={handleSearchIdPonBoxClick} style={{textShadow: '2px 2px 4px #242424'}}>
                 Поиск
               </button>
             </div>
 
             <div style={{ display: "flex" }}>
               <div style={{ flex: 1, maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                  {foundPonBox && (
                      <div style={{ gap: "10px", marginBottom: "10px" }} className='divBodyConnectModal'>
                      <span>
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Округ:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successPonBoxId && successPonBoxId[foundPonBox.id]
                            ? successPonBoxId[foundPonBox.id].canton
                            : foundPonBox.canton}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Регион:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successPonBoxId && successPonBoxId[foundPonBox.id]
                            ? successPonBoxId[foundPonBox.id].region
                            : foundPonBox.region}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Ветка:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successPonBoxId && successPonBoxId[foundPonBox.id]
                            ? successPonBoxId[foundPonBox.id].area
                            : foundPonBox.area}
                        </span>
                      </span>
                        <br />
                        <input
                          type="number"
                          placeholder="номер ветки"
                          style={{marginBottom: "10px"}}
                          className="inputDescriptionModal"
                        />
                        <button className="buttonIsSaveDialog2"
                        onClick={(e) => handleFixPonBoxClick(foundPonBox.id, e.target.previousSibling.value)}>
                          Закрепить
                        </button>  
                  </div>
                )}          
               </div>
 
               <div style={{ flex: 1, height: "400px", marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                   <MapUpdater /> 
                   {foundPonBox && foundPonBox.latitude && foundPonBox.longitude && (
                      <Marker position={[foundPonBox.latitude, foundPonBox.longitude]} icon={iconPonBox}>
                        <Popup autoClose={false} className="custom-popup">
                          <div>
                          <label style={{ fontSize: '13px' }}>
                            <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                            <span style={{ color: '#363636' }}>{foundPonBox.id}</span>
                          </label>
                            <br/>
                            <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Коммент: </span>
                              <span style={{ color: '#363636' }}>{foundPonBox.description}</span>
                            </label>
                          </div>
                        </Popup>
                      </Marker>
                    )}
                 </MapContainer>
               </div>
             </div>
             </>
        )}


         {/* Перезакрепление Муфты по ID */}
         {tabIndex === 3 && (
             <>
             <div>
              <input
                  type="number"
                  placeholder="Введите ID муфты"
                  className="inputDescriptionModal"
                  style={{width: '180px'}}
                  value={inputCouplingId}
                  onChange={(e) => setInputCouplingId(e.target.value)}
                />
 
               <button className="buttonIsDescriptionModal" onClick={handleSearchIdCouplingClick} style={{textShadow: '2px 2px 4px #242424'}}>
                 Поиск
               </button>
             </div>
 
             <div style={{ display: "flex" }}>
               <div style={{ flex: 1, maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                  {foundCoupling && (
                      <div style={{ gap: "10px", marginBottom: "10px" }} className='divBodyConnectModal'>
                      <span>
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Округ:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successCouplingId && successCouplingId[foundCoupling.id]
                            ? successCouplingId[foundCoupling.id].canton
                            : foundCoupling.canton}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Регион:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successCouplingId && successCouplingId[foundCoupling.id]
                            ? successCouplingId[foundCoupling.id].region
                            : foundCoupling.region}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Ветка:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successCouplingId && successCouplingId[foundCoupling.id]
                            ? successCouplingId[foundCoupling.id].area
                            : foundCoupling.area}
                        </span>
                      </span>
                        <br />
                        <input
                          type="number"
                          placeholder="номер ветки"
                          style={{marginBottom: "10px"}}
                          className="inputDescriptionModal"
                        />
                        <button className="buttonIsSaveDialog2"
                        onClick={(e) => handleFixCouplingClick(foundCoupling.id, e.target.previousSibling.value)}>
                          Закрепить
                        </button>  
                  </div>
                )}          
               </div>
 
               <div style={{ flex: 1, height: "400px", marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                   <MapUpdater /> 
                   {foundCoupling && foundCoupling.latitude && foundCoupling.longitude && (
                      <Marker position={[foundCoupling.latitude, foundCoupling.longitude]} icon={iconCoupling}>
                        <Popup autoClose={false} className="custom-popup">
                          <div>
                          <label style={{ fontSize: '13px' }}>
                            <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                            <span style={{ color: '#363636' }}>{foundCoupling.id}</span>
                          </label>
                            <br/>
                            <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Коммент: </span>
                              <span style={{ color: '#363636' }}>{foundCoupling.description}</span>
                            </label>
                          </div>
                        </Popup>
                      </Marker>
                    )}
                 </MapContainer>
               </div>
             </div>
             </>
        )}


         {/* Перезакрепление Фоб по ID */}
         {tabIndex === 4 && (
             <>
             <div>
              <input
                  type="number"
                  placeholder="Введите ID фоб"
                  className="inputDescriptionModal"
                  style={{width: '180px'}}
                  value={inputFobId}
                  onChange={(e) => setInputFobId(e.target.value)}
                />
 
               <button className="buttonIsDescriptionModal" onClick={handleSearchIdFobClick} style={{textShadow: '2px 2px 4px #242424'}}>
                 Поиск
               </button>
             </div>
 
             <div style={{ display: "flex" }}>
               <div style={{ flex: 1, maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                  {foundFob && (
                      <div style={{ gap: "10px", marginBottom: "10px" }} className='divBodyConnectModal'>
                      <span>
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Округ:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successFobId && successFobId[foundFob.id]
                            ? successFobId[foundFob.id].canton
                            : foundFob.canton}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Регион:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successFobId && successFobId[foundFob.id]
                            ? successFobId[foundFob.id].region
                            : foundFob.region}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Ветка:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successFobId && successFobId[foundFob.id]
                            ? successFobId[foundFob.id].area
                            : foundFob.area}
                        </span>
                      </span>
                        <br />
                        <input
                          type="number"
                          placeholder="номер ветки"
                          style={{marginBottom: "10px"}}
                          className="inputDescriptionModal"
                        />
                        <button className="buttonIsSaveDialog2"
                        onClick={(e) => handleFixFobClick(foundFob.id, e.target.previousSibling.value)}>
                          Закрепить
                        </button>  
                  </div>
                )}          
               </div>
 
               <div style={{ flex: 1, height: "400px", marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                   <MapUpdater /> 
                   {foundFob && foundFob.latitude && foundFob.longitude && (
                      <Marker position={[foundFob.latitude, foundFob.longitude]} icon={iconFob}>
                        <Popup autoClose={false} className="custom-popup">
                          <div>
                          <label style={{ fontSize: '13px' }}>
                            <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                            <span style={{ color: '#363636' }}>{foundFob.id}</span>
                          </label>
                            <br/>
                            <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Коммент: </span>
                              <span style={{ color: '#363636' }}>{foundFob.description}</span>
                            </label>
                          </div>
                        </Popup>
                      </Marker>
                    )}
                 </MapContainer>
               </div>
             </div>
             </>
        )}

         {/* Перезакрепление Опору по ID */}
         {tabIndex === 5 && (
             <>
             <div>
              <input
                  type="number"
                  placeholder="Введите ID опоры"
                  className="inputDescriptionModal"
                  style={{width: '180px'}}
                  value={inputPillarId}
                  onChange={(e) => setInputPillarId(e.target.value)}
                />
 
               <button className="buttonIsDescriptionModal" onClick={handleSearchIdPillarClick} style={{textShadow: '2px 2px 4px #242424'}}>
                 Поиск
               </button>
             </div>
 
             <div style={{ display: "flex" }}>
               <div style={{ flex: 1, maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                  {foundPillar && (
                      <div style={{ gap: "10px", marginBottom: "10px" }} className='divBodyConnectModal'>
                      <span>
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Округ:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successPillarId && successPillarId[foundPillar.id]
                            ? successPillarId[foundPillar.id].canton
                            : foundPillar.canton}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Регион:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successPillarId && successPillarId[foundPillar.id]
                            ? successPillarId[foundPillar.id].region
                            : foundPillar.region}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Ветка:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successPillarId && successPillarId[foundPillar.id]
                            ? successPillarId[foundPillar.id].area
                            : foundPillar.area}
                        </span>
                      </span>
                        <br />
                        <input
                          type="number"
                          placeholder="номер ветки"
                          style={{marginBottom: "10px"}}
                          className="inputDescriptionModal"
                        />
                        <button className="buttonIsSaveDialog2"
                        onClick={(e) => handleFixPillarClick(foundPillar.id, e.target.previousSibling.value)}>
                          Закрепить
                        </button>  
                  </div>
                )}          
               </div>
 
               <div style={{ flex: 1, height: "400px", marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                   <MapUpdater /> 
                   {foundPillar && foundPillar.latitude && foundPillar.longitude && (
                      <Marker position={[foundPillar.latitude, foundPillar.longitude]} icon={iconPillar}>
                        <Popup autoClose={false} className="custom-popup">
                          <div>
                          <label style={{ fontSize: '13px' }}>
                            <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                            <span style={{ color: '#363636' }}>{foundPillar.id}</span>
                          </label>
                            <br/>
                            <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Коммент: </span>
                              <span style={{ color: '#363636' }}>{foundPillar.description}</span>
                            </label>
                          </div>
                        </Popup>
                      </Marker>
                    )}
                 </MapContainer>
               </div>
             </div>
             </>
        )}

        {/* Перезакрепление колодец по ID */}
         {tabIndex === 6 && (
             <>
             <div>
              <input
                  type="number"
                  placeholder="Введите ID колодеца"
                  className="inputDescriptionModal"
                  style={{width: '180px'}}
                  value={inputWellId}
                  onChange={(e) => setInputWellId(e.target.value)}
                />
 
               <button className="buttonIsDescriptionModal" onClick={handleSearchIdWellClick} style={{textShadow: '2px 2px 4px #242424'}}>
                 Поиск
               </button>
             </div>
 
             <div style={{ display: "flex" }}>
               <div style={{ flex: 1, maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                  {foundWell && (
                      <div style={{ gap: "10px", marginBottom: "10px" }} className='divBodyConnectModal'>
                      <span>
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Округ:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successWellId && successWellId[foundWell.id]
                            ? successWellId[foundWell.id].canton
                            : foundWell.canton}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Регион:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successWellId && successWellId[foundWell.id]
                            ? successWellId[foundWell.id].region
                            : foundWell.region}
                        </span>,{" "}
                        <span style={{ color: "#3f3f3f", fontWeight: "bold" }}>Ветка:</span>{" "}
                        <span style={{ color: "#252525" }}>
                          {successWellId && successWellId[foundWell.id]
                            ? successWellId[foundWell.id].area
                            : foundWell.area}
                        </span>
                      </span>
                        <br />
                        <input
                          type="number"
                          placeholder="номер ветки"
                          style={{marginBottom: "10px"}}
                          className="inputDescriptionModal"
                        />
                        <button className="buttonIsSaveDialog2"
                        onClick={(e) => handleFixWellClick(foundWell.id, e.target.previousSibling.value)}>
                          Закрепить
                        </button>  
                  </div>
                )}          
               </div>
 
               <div style={{ flex: 1, height: "400px", marginLeft: "20px" }}>
                 <MapContainer center={mapCenter} zoom={mapZoom} style={{ height: "100%", width: "100%" , borderRadius: "20px",  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)"}}>
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                   <MapUpdater /> 
                   {foundWell && foundWell.latitude && foundWell.longitude && (
                      <Marker position={[foundWell.latitude, foundWell.longitude]} icon={iconManhole}>
                        <Popup autoClose={false} className="custom-popup">
                          <div>
                          <label style={{ fontSize: '13px' }}>
                            <span style={{ color: '#000000', fontWeight: 'bold' }}>ID: </span>
                            <span style={{ color: '#363636' }}>{foundWell.id}</span>
                          </label>
                            <br/>
                            <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Коммент: </span>
                              <span style={{ color: '#363636' }}>{foundWell.description}</span>
                            </label>
                          </div>
                        </Popup>
                      </Marker>
                    )}
                 </MapContainer>
               </div>
             </div>
             </>
        )}
          </DialogContent>

          <DialogActions>
            <Button class="buttonIsHideModal" onClick={handleClose}>
              Закрыть
            </Button>
          </DialogActions>

          {/* Snackbar */}
                <Snackbar
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    message={snackbarMessage}
                    ContentProps={{
                      style: {
                        color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                      }
                    }}
                  />
    </Dialog>
  );
};

export default ModalFasteningErrors;